import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import ReactPaginate from "react-paginate";
import queryString from "query-string";

import Spinner from "../../components/generics/Spinner";
import Filter from "../../components/generics/Filter";
import ListHeader from "../../components/generics/ListHeader";
import { renderResponseAsString } from "../../utils/Helpers";

import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";

import { STARTING_PAGE } from "../../constants/constants";

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";

import ModalUploadPricesList from "../../components/priceLists/ModalUploadPricesList";
import ModalUploadOfferItems from "../../components/priceLists/ModalUploadOfferItems";

import {
  fetchPriceLists,
  fetchPriceListsSuccess,
  fetchPriceListsFailure,
  pricesListSubmit,
  pricesListSubmitSuccess,
  pricesListSubmitFailure,
} from "../../store/priceLists/actions";

import { deletePricesList, offerItemsListSubmit } from "../../store/priceLists/api";

import PriceListsList from "../../components/priceLists/PriceListsList";
import { withRouter } from "utils/WithRouter";

const PriceListsListContainer = ({ location, history, fetchPriceLists, fetchVendors, pricesListSubmit, priceListsList, vendorsList }) => {
  const [page, setPage] = useState(1);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [vendor, setVendor] = useState(undefined);
  const [isOpenUploadPricesModal, setOpenUploadPricesModal] = useState(false);
  const [isOpenUploadOfferItemsModal, setOpenUploadOfferItemsModal] = useState(false);
  const [isOpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [pricesListToDelete, setPricesListToDelete] = useState();
  const [checkedLists, setCheckedLists] = useState([]);
  const [submitPricesLoading, setSubmitPricesLoading] = useState(false);
  const [submitOfferItemsLoading, setSubmitOfferItemsLoading] = useState(false);

  const alertRef = useRef(null);

  useEffect(() => {
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const dateFrom = params.dateFrom ? params.dateFrom : "";
    const dateTo = params.dateTo ? params.dateTo : "";
    const vendor = params.vendor ? params.vendor : undefined;
    fetchVendors();
    fetchPriceLists(page, vendor, dateFrom, dateTo);
  }, []);

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------

  useEffect(() => {
    filterList();
  }, [dateFrom, dateTo, vendor, page]);

  const onFromDateChange = (event) => {
    const date = event.target.value ? event.target.value : "";
    setPage(STARTING_PAGE);
    setDateFrom(date);
  };

  const onToDateChange = (event) => {
    const date = event.target.value ? event.target.value : "";
    setPage(STARTING_PAGE);
    setDateTo(date);
  };

  const onVendorChange = (event) => {
    const vendor = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    setPage(STARTING_PAGE);
    setVendor(vendor);
  };

  const filterList = () => {
    let params = {};
    params.page = page;

    if (dateFrom) {
      params.dateFrom = dateFrom;
    }
    if (dateTo) {
      params.dateTo = dateTo;
    }
    if (vendor) {
      params.vendor = vendor;
    }
    history.replace({
      search: queryString.stringify(params),
    });
    fetchPriceLists(page, vendor, dateFrom, dateTo);
  };

  // ---------------------------------------------------------------------------
  // Deletion
  // ---------------------------------------------------------------------------

  const handleDeleteModal = (pricesListId) => {
    setPricesListToDelete(pricesListId);
    setOpenDeleteModal(true);
  };

  const handleDelete = (pricesListId) => {
    deletePricesList(pricesListId).then(
      () => {
        alertRef.current.sendAlert(`Prices list #${pricesListId} has been deleted successfully`, "success");
        // Refresh List
        fetchPriceLists(page, vendor, dateFrom, dateTo);
      },
      () => {
        alertRef.current.sendAlert(`Prices list #${pricesListId} couldn't be deleted`);
      }
    );
    setOpenDeleteModal(false);
  };

  // ---------------------------------------------------------------------------
  // Compare lists
  // ---------------------------------------------------------------------------

  const handleCheck = (id) => {
    setCheckedLists(checkedLists.includes(id) ? checkedLists.filter((listId) => listId !== id) : [...checkedLists, id]);
  };

  // ---------------------------------------------------------------------------
  // Offer items creation
  // ---------------------------------------------------------------------------

  const createOfferItems = (data) => {
    setOpenUploadOfferItemsModal(false);
    setSubmitOfferItemsLoading(true);
    offerItemsListSubmit(data).then((response) => {
      if (response && response.headers["content-type"].startsWith("text/csv")) {
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Result - " + data.file.name);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Invalid file response");
      }
      setSubmitOfferItemsLoading(false);
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  const handlePageRequest = (data) => {
    let newPage = data.selected + 1;
    if (newPage !== page) {
      setPage(newPage);
    }
  };

  const toggleUploadPricesListModal = () => {
    setOpenUploadPricesModal(!isOpenUploadPricesModal);
  };

  const toggleUploadOfferItemsModal = () => {
    setOpenUploadOfferItemsModal(!isOpenUploadOfferItemsModal);
  };

  const handleCreateOffers = (file, date, vendorId, description) => {
    setOpenUploadPricesModal(false);
    setSubmitPricesLoading(true);
    pricesListSubmit(file, date, vendorId, description, alertRef, history, setSubmitPricesLoading);
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  return priceListsList.loading || submitPricesLoading || submitOfferItemsLoading ? (
    <div className="animated fadeIn">
      <Spinner />
      <Alert ref={alertRef} />
    </div>
  ) : (
    <div className="animated fadeIn">
      <Alert ref={alertRef} />
      <div className="card">
        <ListHeader
          dark
          showAction={false}
          title="Uploaded price lists"
          iconClass="fa fa-wpforms mr-05"
          buttons={[
            // {
            //   buttonTitle: "Download template",
            //   buttonAction: () => handleTemplateDownload(),
            //   buttonClass: "btn btn-secondary m-0 mr-1",
            // },
            {
              buttonTitle: "Create offer items in batch",
              buttonAction: () => toggleUploadOfferItemsModal(),
              buttonClass: "btn btn-primary m-0 mr-1",
            },
            {
              buttonTitle: "Compare lists",
              buttonAction:
                checkedLists.length !== 0 ? () => history.push(`/compare_price_lists?ids=${checkedLists.join(",")}`) : undefined,
              buttonClass: `${checkedLists.length === 0 ? "btn btn-primary-grey disabled m-0 mr-1" : "btn btn-primary m-0 mr-1"}`,
              disabled: checkedLists.length === 0,
            },
            {
              buttonTitle: "Add a new price list",
              buttonAction: () => toggleUploadPricesListModal(),
              buttonClass: "btn btn-primary m-0",
            },
          ]}
        />
        <Filter
          dateLabel="Filter by date from"
          dateVal={dateFrom}
          onDateChange={onFromDateChange}
          dateLabel2="Filter by date to"
          dateVal2={dateTo}
          onDateChange2={onToDateChange}
          dropdownLabel2="Filter by vendor"
          dropdownPlaceholder2="Select vendor"
          dropdownVal2={vendor}
          onDropdownChange2={onVendorChange}
          dropdownByElementId2
          dropdownOptions2={vendorsList ? vendorsList.vendors.results : []}
          colClass="col-12 col-sm-3"
        />
      </div>
      <div className="card">
        <div className="card-block p-0">
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>List Date</th>
                <th>Description</th>
                <th>Vendor</th>
                <th>Actions</th>
                <th>Compare</th>
              </tr>
            </thead>
            <PriceListsList
              priceLists={priceListsList.priceLists}
              handleDelete={handleDeleteModal}
              handleCheck={handleCheck}
              checkedLists={checkedLists}
            />
          </table>
          {priceListsList.pages > 1 && (
            <ReactPaginate
              pageCount={priceListsList.pages}
              pageRangeDisplayed={2}
              marginPagesDisplayed={1}
              previousLabel="<"
              nextLabel=">"
              onPageChange={handlePageRequest}
              initialPage={page - 1}
              disableInitialCallback={true}
              containerClassName="pagination"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              activeClassName="page-item active"
              previousClassName="paginate_button previous"
              nextClassName="paginate_button next"
              disabledClassName="page-item disabled"
              forcePage={page - 1}
            />
          )}
        </div>
      </div>
      {priceListsList.loading ? <Spinner /> : null}
      {isOpenDeleteModal && (
        <Modal
          closeModal={() => setOpenDeleteModal(false)}
          isModalOpen={pricesListToDelete}
          onConfirm={() => handleDelete(pricesListToDelete)}
          onCancel={() => setOpenDeleteModal(false)}
          header="Delete Prices list"
          content={`Are you sure you want to delete list #${pricesListToDelete}?`}
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
      )}
      {isOpenUploadPricesModal && (
        <ModalUploadPricesList
          isModalOpen={isOpenUploadPricesModal}
          closeModal={toggleUploadPricesListModal}
          onSubmit={handleCreateOffers}
          vendors={vendorsList ? vendorsList.vendors.results : []}
        />
      )}
      {isOpenUploadOfferItemsModal && (
        <ModalUploadOfferItems
          isModalOpen={isOpenUploadOfferItemsModal}
          closeModal={toggleUploadOfferItemsModal}
          onSubmit={createOfferItems}
          vendors={vendorsList ? vendorsList.vendors.results : []}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    priceListsList: state.priceLists.priceListsList,
    vendorsList: state.invoices.vendorsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPriceLists: (page, vendor, dateFrom, dateTo) => {
      dispatch(fetchPriceLists(page, vendor, dateFrom, dateTo)).payload.then(
        (response) => {
          dispatch(fetchPriceListsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchPriceListsFailure(error));
        }
      );
    },
    fetchVendors: () => {
      dispatch(fetchVendors()).payload.then(
        (response) => {
          dispatch(fetchVendorsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchVendorsFailure(error));
        }
      );
    },
    pricesListSubmit: (file, date, vendorId, description, alertRef, history, setSubmitPricesLoading) => {
      dispatch(pricesListSubmit(file, date, vendorId, description)).payload.then(
        (response) => {
          dispatch(pricesListSubmitSuccess(response.data));
          alertRef.current.sendAlert("List was successfully uploaded", "success");
          history.push(`/price_lists/${response.data}`);
        },
        (error) => {
          dispatch(pricesListSubmitFailure(error));
          setSubmitPricesLoading(false);
          const response =
            error.response.status === 500
              ? error.response.statusText
              : `An error rised while processing the list: ${renderResponseAsString(error.response.data)}` || error.response.statusText;
          alertRef.current.sendAlert(response);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PriceListsListContainer));
